"use client";
import { createContext, useContext } from "react";
import type { DotcomAuthSession } from "./types";

const noop = async () => {
  /* empty */
};

export const DEFAULT_DOTCOM_AUTH_SESSION: DotcomAuthSession = {
  accessToken: undefined,
  error: null,
  handleLogin: noop,
  handleLogout: noop,
  status: "unauthenticated",
};
export const DotcomAuthContext = createContext<DotcomAuthSession>(
  DEFAULT_DOTCOM_AUTH_SESSION,
);
export const useDotcomAuth = () => useContext(DotcomAuthContext);
